// extracted by mini-css-extract-plugin
module.exports = {"sortItem":"sortItem_sortItem__hjiS4","sortItem_increase":"sortItem_sortItem_increase__kJ8uQ"};